import { ReactNode } from "react";
import {
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link } from "react-router-dom";

interface Props {
  icon: ReactNode;
  label: string;
  link: string;
  active: boolean;
}

const NavigationItems = ({ icon, label, link, active }: Props) => {

  return (
    <ListItem
      disablePadding
      // sx={{ bgcolor: active ? "rgba(0, 0, 0, 0.04)" : "transparent" }}
    >
      <ListItemButton component={Link} to={link} selected={active}>
        <ListItemIcon>{icon}</ListItemIcon>

        <ListItemText
          primary={label}
          sx={{
            ml: -1,
            color: active ? "primary.main" : "inherit",
            textWrap: "pretty",
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default NavigationItems;
